// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  /*restBaseUrl: 'http://localhost:8080/locatelli/rest/v2/',
  restBaseRedirect: 'http://localhost:8080/locatelli/#mdl=',
  baseUrl: 'http://localhost:8080/locatelli/',*/
  restBaseUrl: 'https://testservice.atb.bergamo.it/locatelli/rest/v2/',
  restBaseRedirect: 'https://testservice.atb.bergamo.it/locatelli/#mdl=',
  baseUrl: 'https://testservice.atb.bergamo.it/locatelli/',
  version: '1.0.0',
  rows: 5
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts